
  <div class="row" *ngIf="Breadcrumblist!=null">
    <div class="col-12 p-0 border-bottom headersize">
      <app-breadcrumb [Breadcrumblist]="Breadcrumblist"></app-breadcrumb>
    </div>
  </div>
 <div class="row">
  <div class="col-12" style="height: 65vh !important; overflow: auto;">
    <form [formGroup]="AddQuestionStatusform">
    <div class="col-12">
      <div class="row pt-2">
        <div class="col-3">
          <div class="d-flex  flex-row-reverse">
            <div class="p-0">Question Number&nbsp;:&nbsp;</div>
          </div>
        </div>
        <div class="col-9 ">
          {{this.AddQuestionStatusform.value.Question_ID}}
          <!-- <input type="text" class="form-control form-control-sm input-txt" formControlName="Question_ID" readonly /> -->
        </div>
      </div>
    </div>
    <!-- <div class="col-12" *ngIf="getcodes!=null">
      <div class="row pt-2">
        <div class="col-2 text-right pr-0 pt-1 pl-0">
          <div class="d-flex  flex-row-reverse">
            <div class="p-0 label-red">*</div>       
            <div class="p-0">{{Questionstatus}} Reason</div>
          </div>
        </div>
        <div class="col-10">
          <div class="row pl-2" *ngFor="let s of getcodes">
            <div class="col-10">
          <div class="form-check p-1" style="padding-top: 1px;">
            <input type="checkbox" [value]="s.Code" (change)="selectevent($event)" [checked]="s.checkedflag" class="form-check-input chkbx-size p-0">
            <label class="form-check-label pt-1">{{s.Description}}</label>
          </div>
          </div>
          </div>
          <div class="row pt-1">
            <div class="col-10"><label  class="Valid1" *ngIf="error1.isError">{{ error1.errorMessage }}</label></div>
          </div>
        </div>

        </div>
      </div> -->
      <div class="col-12" *ngIf="getcodes!=null">
        <div class="row pt-2">
          <div class="col-3 text-right pr-0">
            <div class="d-flex  flex-row-reverse">
              <div class="p-0 label-red">*</div>       
              <div class="p-0">{{Questionstatus}} Reason</div>
            </div>
            <div class="d-flex flex-row-reverse">
     
              <div class="p-0">(Select all that apply)</div>
            </div>
          </div>
          <div class="col-9" style="max-height: 14vh !important;min-height: 7vh !important; overflow: auto; line-height: .9em;">
            <div class="row pl-2" *ngFor="let s of getcodes">            
              <div class="col-10 pl-0">
            <div class="form-check p-0 m-0">
              <input type="checkbox" class="form-check-input chkbx-size p-0 m-0" [value]="s.Code" (change)="selectevent($event)" [checked]="s.checkedflag" 
              >
              <label class="form-check-label  pl-3 px-1">{{s.Description}}</label>
            </div>
            </div>
            </div>
            
          </div>
           <div class="col-3">
  
           </div>
            <div class="col-9 pl-2"><label  class="Valid1" *ngIf="error1.isError">{{ error1.errorMessage }}</label></div>
      
  
          </div>
        </div>




    <div class="col-12 text-right">
      <div class="row pt-2">
        <div class="col-3 text-right pr-0 pt-1 pl-0">        
          <div class="d-flex  flex-row-reverse">
        <div class="p-0">Review Comment</div></div> </div>
        <div class="col-9 pl-2">
          <textarea formControlName="Comment_Text"  (ngModelChange)="Descriptioncount()" maxlength="4000" class="form-control input-txt1" id="txtAssignmentIntruction"></textarea>
          <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
        </div>
        <div class="col-3 pr-0 pt-1 pl-0"></div>
        
      </div>
    </div>
    <div class="col-12">
    <div class="row">
      <div class="col-3">

      </div>
      <div class="col-9 px-3">
        <div class=" d-flex">
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" (click)="AddQuestionStatus()" class="btn btn-sm bl-btn">Save</button>
          </div>
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" (click)="Cancel()" class="btn btn-sm bg-light border">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    </div>
  </form>
  </div> 
 </div>
  
  
